import { requestHandler } from '../../api';

export const submitVerification = async (dispatch: any, data: any) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  const response = await requestHandler({
    method: 'post',
    url: `internal/invoiceConfirmation/batch`,
    data: data.data,
    headers,
    dispatch,
  });
  if (response) return response.data;
};

export const fetchAllVerifications = async (
  dispatch: any,
  queryParams: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/invoiceConfirmation?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const fetchAllVerificationsByOperation = async (
  dispatch: any,
  queryParams: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/invoiceConfirmation/byRequest?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const fetchVerificationsPortfolio = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/invoiceConfirmation/portfolio`,
    dispatch,
  });
  if (response) return response.data;
};

export const unAssignVerifierToOperations = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/invoiceConfirmation/unAssignVerifier`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const assignVerifierToOperations = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/invoiceConfirmation/assignVerifier`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentVerifications = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/invoiceConfirmation/document/${data.documentId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const downloadVerificationFile = async (dispatch: any, fileKey: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/invoiceConfirmation/download-verification-file`,
    data: { fileKey },
    dispatch,
  });
  if (response) return response.data;
};
